<template>
    <section :class="[{'oculto':!show},'errores-alertas','noPadding','noMargin']" >
        <div class="modal">
            <div class="content-toast">
                <div class="card head-card msn-alert rosa ">
                    <div class="title-card">
                        <h4>Confirmación</h4>
                    </div> 
                    <div class="card-content">
                        <p class="margin-15" v-if="smsModal">{{smsModal}}</p>
                            <div class="page-actions margin-15">
                                <button class="button small" @click="aceptar">Aceptar</button>
                                <button class="button small outline" @click="cancelar">Cancelar</button>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: 'confirmModal',
    props:['smsModal','show'],
     data() {
        return {
        }
    },
    methods:{
        cancelar(){
            this.$emit('cancelar');
        },
        aceptar(){
             this.$emit('aceptar');
        }
    }
}

</script>
<style  scoped>
.oculto{
    display: none;
}

.modal .content-toast {
bottom: 50%;
}
</style>